export default {"src":"/_next/static/media/red-paw.94be23b9.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};